import useIsMobile from '@/helpers/commonHooks/useIsMobile'
import PricingPagePc from './components/PricingPagePc/PricingPagePc'
import { observer } from 'mobx-react'
import PricingPageMobile from './components/PricingPageMobile/PricingPageMobile'

function PricingPage() {
  const isMobile = useIsMobile()
  return isMobile ? <PricingPageMobile /> : <PricingPagePc />
}

export default observer(PricingPage)
